import { Controller } from "stimulus"

// Shows a skeleton loading state when a turbo frame navigates.
// Attach to a turbo-frame element. When the frame starts loading,
// replaces content with skeleton rows. When loading finishes,
// the frame's content is replaced by the server response anyway.
export default class extends Controller {
  connect() {
    this.element.addEventListener("turbo:before-fetch-request", this.showSkeleton.bind(this))
  }

  disconnect() {
    this.element.removeEventListener("turbo:before-fetch-request", this.showSkeleton.bind(this))
  }

  showSkeleton() {
    // Don't show skeleton for filter/pagination requests (only tab switches)
    const skeletonHTML = this.buildSkeleton()
    // Keep the feed header if it exists, replace everything after it
    const header = this.element.querySelector('.ai-jobs-feed-header')
    if (header) {
      // Remove everything after the header
      while (header.nextSibling) {
        header.nextSibling.remove()
      }
      const container = document.createElement('div')
      container.innerHTML = skeletonHTML
      this.element.appendChild(container)
    }
  }

  buildSkeleton() {
    let rows = ''
    for (let i = 0; i < 8; i++) {
      rows += `
        <div class="p-2 border-bottom ai-job-item">
          <div class="d-flex align-items-center">
            <div class="flex-grow-1">
              <div class="d-flex align-items-center mb-1">
                <span class="skeleton-pulse" style="width: 80px; height: 20px; border-radius: 10px;"></span>
                <span class="skeleton-pulse ml-2" style="width: ${150 + Math.random() * 150}px; height: 18px; border-radius: 4px;"></span>
              </div>
              <span class="skeleton-pulse" style="width: ${60 + Math.random() * 30}%; height: 14px; border-radius: 4px;"></span>
            </div>
            <span class="skeleton-pulse ml-2" style="width: 20px; height: 20px; border-radius: 50%;"></span>
          </div>
        </div>
      `
    }
    return `<div class="ai-jobs-feed">${rows}</div>`
  }
}
